import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/activityItem/findActivityRefundApplication',
    method: 'post',
    data: data
  });
}
export function refundApproval(data) {
  return request({
    url: '/whg-park/api/activityItem/refundApproval',
    method: 'post',
    data: data
  });
}